export default __webpack_public_path__ + "static/media/laptop_campaign.c7f6b05f.png";